export const AUDIT_LOG_MODULES = [
  {
    name: "inventory",
    color: "#06B6D4",
  },
  {
    name: "auth",
    color: "#000000",
  },
  {
    name: "accounting",
    color: "#7F79A2",
  },
  {
    name: "pos",
    color: "#31B5A9",
  },
  {
    name: "hr",
    color: "#9B2F5D",
  },
];

export const getModuleColor = (moduleName: string) => {
  const moduleData = AUDIT_LOG_MODULES.find((m) => m.name === moduleName);
  return moduleData?.color || "#000000";
};
